import './index.sass';

export default () => {
  const $albumType = $('.js-select-album-type');

  if($albumType.length) {
    const $input = $('#album_illustration_type_id, #illustration_illustration_type_id');
    $albumType.on('change', function() {
      $input.val($(this).val()).trigger('change');
    })
  }
  const $albumIds = $('.js-album-style-ids');
  if($albumIds.length) {
    $albumIds.on('change', function() {
      $('#album_art_style_ids').val($(this).val());
    })
  }
  const $albumTechniques = $('.js-album-techniques');
  if($albumTechniques.length) {
    $albumTechniques.on('change', function() {
      $('#album_art_technique_ids').val($(this).val());
    })
  }
}